import React from "react";
import "react-credit-cards/es/styles-compiled.css";
import { Icon } from "@iconify/react";
import "./ManageSubscription.scss";
import Cards from "react-credit-cards";

const CreditCard = ({ number, name, expiry, cvc, onEditClick }) => {
  return (
    <div className="CardDebit">
      <Cards number={number} name={name} expiry={expiry} cvc="***" focused="number" />
      <button
        className="EditButton"
        onClick={onEditClick}
        style={{
          position: "absolute",
          top: "10px",
          right: "10px",
          background: "none",
          border: "none",
          cursor: "pointer",
        }}
      >
        <Icon icon="fa-solid:pen" color="white" width={20} height={20} />
      </button>
    </div>
  );
};

export default CreditCard;
